import React from 'react'
import { SanityAnnualReviews } from '../../../../../types/generated/graphql-types'
import { mapSanityAnnualReviewsToAnnualReviewsNewDesignProps } from '../../../../mapping/ReportsMapper'
import { BlockWithId } from '../../../../utilities/blockId'
import { AnnualReviewsNewDesign } from '../../../blocks/AnnualReviewsNewDesign'
import { MarketSection } from '../../../MarketSection'

export const AnnualReviewsSerializer = ({
  id,
  ...props
}: SanityAnnualReviews & BlockWithId) => (
  <MarketSection applyGrid={false} id={id}>
    <AnnualReviewsNewDesign
      {...mapSanityAnnualReviewsToAnnualReviewsNewDesignProps(props)}
    />
  </MarketSection>
)
